module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#sports",
      toString: function () {
        return this.url;
      }
    }